import { render, staticRenderFns } from "./modelNine.vue?vue&type=template&id=83944474&scoped=true&"
import script from "./modelNine.vue?vue&type=script&lang=js&"
export * from "./modelNine.vue?vue&type=script&lang=js&"
import style0 from "./modelNine.vue?vue&type=style&index=0&id=83944474&lang=scss&scoped=true&"
import style1 from "./modelNine.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83944474",
  null
  
)

export default component.exports